export const SendingStatus = {
    AWAITING: 'AWAITING',
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
};
